import CoreDrawer from '@/components/CoreDrawer';
import { Spin } from 'antd';
import { get } from 'lodash';
import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import GetDetailBusinessUnit from '../../viewmodels/business-unit-detail.viewmodel';
import { BusinessUnitForm } from './BusinessUnitForm';

interface Props {
  open: boolean;
  handleClose: () => void;
  setOpen: (value: boolean) => void;
}

export const DetailBusinessUnit = (props: Props) => {
  const { open, setOpen, handleClose } = props;
  const { loadingBusinessUnit, errorBusinessUnit, detailBusinessUnit, actionGetDetail } =
    GetDetailBusinessUnit();

  const [currentQueryParameters] = useSearchParams();
  const showId = currentQueryParameters.get('id');
  const getAction = currentQueryParameters.get('action');

  useEffect(() => {
    if ((showId !== null && getAction === 'Detail') || getAction === 'Create') {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [open, handleClose, setOpen]);

  useEffect(() => {
    if (showId) {
      actionGetDetail();
    }
  }, [open]);

  const renderContent = () => {
    return (
      <>
        <div>{loadingBusinessUnit && <Spin />}</div>
        {errorBusinessUnit && <div>Error</div>}
        {!errorBusinessUnit && !loadingBusinessUnit && (
          <BusinessUnitForm detailBusinessUnit={get(detailBusinessUnit, 'data')} openForm={open} />
        )}
      </>
    );
  };

  return (
    <CoreDrawer
      open={open}
      onClose={() => handleClose()}
      content={renderContent()}
      bodyStyle={{ marginTop: '20px' }}
    />
  );
};
